import { Component, inject, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { OpportunitySnapshotsService } from '../../services/opportunity-snapshots.service';
import { SurplusLinesExistingCoverage, SurplusLinesPlanDesignsRequest } from '../../models/surplus-lines-plan-design.model';

@Component({
  selector: 'app-liability-premium',
  standalone: false,
  templateUrl: './liability-premium.component.html',
  styleUrl: '../../../assets/css/HighLimitsDialogs.css'
})
export class LiabilityPremiumComponent implements OnInit {
  readonly dialogRef = inject(MatDialogRef<LiabilityPremiumComponent>);
  PLPAmount: string = '';
  PLPDuration: string = '';
  PLPDurationOptions: string[] = [];
  PLPAmountOptions: string[] = [];
  monthlyBenefit: string = '';
  eliminationPeriod: string = '';
  cost: string = '';
  planDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();
  additionalPlanDesignRequest: SurplusLinesPlanDesignsRequest = new SurplusLinesPlanDesignsRequest();

  constructor(private _oss: OpportunitySnapshotsService) {
  }

  ngOnInit() {
    this.PLPDurationOptions = this.getLiabilityPremiumDurationOptions();
    this.PLPAmountOptions = this.getLiabilityPremiumAmountOptions();
    if(this.PLPAmount == ''){
      this.PLPAmount = this._oss.currentQuoteOptions?.PLPAmountDefault as string;
    }
    if(this.PLPDuration == ''){
      this.PLPDuration = this._oss.currentQuoteOptions?.PLPDurationDefault as string;
    }

    this.updateCost();
  }

  getLiabilityPremiumDurationOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.PLPDurationOptions.replaceAll('; ', ';').split(';');
  }

  getLiabilityPremiumAmountOptions() {
    if (this._oss.currentQuoteOptions == null) {
      return [];
    }
    return this._oss.currentQuoteOptions.PLPAmountOptions.replaceAll('; ', ';').split(';');
  }

  updateCost() {
    var existingCoverages: SurplusLinesExistingCoverage[] = [];

    this._oss.currentOpportunitySnapshot.OtherInsurance.forEach(element => {
      var existing = new SurplusLinesExistingCoverage();
      existing.Amount = element.MonthlyAmount;
      existing.Type = element.Type;
      existing.Payee = element.Paid;
      existingCoverages.push(existing);
    });

    this.additionalPlanDesignRequest.OpportunityId = this._oss.currentCompassOpportunity?.CompassId as number;
    this.additionalPlanDesignRequest.EarnedIncome = this._oss.currentApplicant.AnnualIncome;
    this.additionalPlanDesignRequest.ExistingCoverages = existingCoverages;
    this.additionalPlanDesignRequest.InsuredId = this._oss.currentCompassOpportunity?.InsuredId as number;
    this.additionalPlanDesignRequest.TTDMonthlyBenefit = this.monthlyBenefit;
    this.additionalPlanDesignRequest.EP = this.eliminationPeriod;
    this.additionalPlanDesignRequest.PLPAmount = this.PLPAmount;
    this.additionalPlanDesignRequest.PLPDuration = this.PLPDuration;
    this.additionalPlanDesignRequest.BenefitDuration = this._oss.currentQuoteOptions?.DurationDefault as string;

    this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.additionalPlanDesignRequest).subscribe(additionalQuote => {
      this._oss.getQuote(this._oss.currentOpportunitySnapshot.OpportunityId, this.planDesignRequest).subscribe(originalQuote => {
        this.cost = String(additionalQuote[0].YearOneCost - originalQuote[0].YearOneCost);
      });
    });
  }

  inclusion(){
    if(this._oss.currentQuoteOptions?.PLPInclusion == 'Y'){
      return true;
    }
    return false;
  }

  yes() {
    this.dialogRef.close({ PLPDuration: this.PLPDuration, PLPAmount: this.PLPAmount, cost: this.cost });
  }

  no() {
    this.dialogRef.close(false);
  }
}
